import React, { useState } from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { checkAndFormatPhoneNumber, getContrastColor } from "../../lib/utils";

export default function ContactSection({ hotel, accentColor = "#14b8a6" }) {
  const [textColor, setTextColor] = useState(getContrastColor(accentColor));

  if (!hotel.with_owner) {
    return null;
  }

  return (
    <section
      id="contacts"
      className="contactSection py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800"
      style={{
        background: `linear-gradient(to bottom right, ${accentColor}, ${accentColor}dd, ${accentColor}bb)`,
        color: textColor,
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">
            Свяжитесь с нами
          </h2>
          <p className="text-teal-100 text-lg mb-12 max-w-2xl mx-auto">
            Готовы забронировать незабываемый отдых? Свяжитесь с нами, и мы
            поможем подобрать идеальный вариант!
          </p>

          {(hotel.with_owner || hotel?.contacts_is_active === true) && (
            <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {hotel?.phone?.[0] && (
                <div className="flex flex-col items-center gap-4">
                  <div className="w-16 h-16 bg-white/10 rounded-xl flex items-center justify-center">
                    <Phone className="w-8 h-8 " />
                  </div>
                  <div>
                    <div className="text-teal-200 text-sm mb-1">Телефон</div>
                    <a
                      href={`tel:${hotel.phone[0]}`}
                      className=" text-xl font-semibold hover:text-teal-200 transition-colors"
                      style={{ color: textColor }}
                    >
                      {checkAndFormatPhoneNumber(hotel.phone[0])[0]}
                    </a>
                  </div>
                </div>
              )}

              {hotel?.email && (
                <div className="flex flex-col items-center gap-4">
                  <div className="w-16 h-16 bg-white/10 rounded-xl flex items-center justify-center">
                    <Mail className="w-8 h-8 " />
                  </div>
                  <div>
                    <div className="text-teal-200 text-sm mb-1">Email</div>
                    <a
                      href={`mailto:${hotel.email}`}
                      className=" text-xl font-semibold hover:text-teal-200 transition-colors break-all"
                      style={{ color: textColor }}
                    >
                      {hotel.email}
                    </a>
                  </div>
                </div>
              )}

              {hotel?.address && (
                <div className="flex flex-col items-center gap-4">
                  <div className="w-16 h-16 bg-white/10 rounded-xl flex items-center justify-center">
                    <MapPin className="w-8 h-8 " />
                  </div>
                  <div>
                    <div className="text-teal-200 text-sm mb-1">Адрес</div>
                    <div className="text-xl font-semibold">{hotel.address}</div>
                  </div>
                </div>
              )}
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
